// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'

export class CreateGroup {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): CreateGroup {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsCreateGroup(bb: flatbuffers.ByteBuffer, obj?: CreateGroup): CreateGroup {
    return (obj || new CreateGroup()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsCreateGroup(bb: flatbuffers.ByteBuffer, obj?: CreateGroup): CreateGroup {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new CreateGroup()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  members(index: number, obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 8, this.bb!) : null
  }

  membersLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  static startCreateGroup(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addMembers(builder: flatbuffers.Builder, membersOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, membersOffset, 0)
  }

  static startMembersVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 4)
  }

  static endCreateGroup(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // members
    return offset
  }

  static createCreateGroup(builder: flatbuffers.Builder, membersOffset: flatbuffers.Offset): flatbuffers.Offset {
    CreateGroup.startCreateGroup(builder)
    CreateGroup.addMembers(builder, membersOffset)
    return CreateGroup.endCreateGroup(builder)
  }
}
